import httpClient from '../api/httpClient.js';

// Generate form default attributes.
const formAtt = (p_params) => {
    let params = {
        id : '',
        label : '',
        type : 'text',
        placeholder : '',
        required : false,
        maxLength : 30,
        value : '',
        disabled : false,
        classCol : 'col-12',
        className : 'form-control'
    }

    return {...params, ...p_params}
}

const errorMessage = (error) => {
    console.error('Error saving matchmaking data:', error);
    if (error.response && error.response.data) {
        if (error.response.data.reason && error.response.data.reason.indexOf('Unique index or primary key') > -1) {
            alert('이미 등록된 정보 입니다.');
        } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.');
        }
    }
}

const ApiUserInfo = async () => {
    return await httpClient.post('/auth/userinfo', {}, {
            withCredentials: true,
        })
        .then(res => {
            let isLoggedIn = false;
            if (res && (res.success || res.status === 200)) {
                if (res.data.data.userInfo) {
                    isLoggedIn = true;
                }
            }
            return { success: isLoggedIn };
        })
        .catch(error => {
            return { success: false };
        });
}

/*---------------------------------*/
// convert base64 to blob
/*---------------------------------*/
const base64ToBlob = (base64, mimeType) => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
}

/*---------------------------------*/
// download pdf
/*---------------------------------*/
const downloadCurrentPdf = (blob, awardNm) => {
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = awardNm + ".pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url); // 메모리 해제
}

//값이 비어있는지 체크.
const isEmpty = (o) => {
    if (o === null || o === '' || o === undefined || o === 'null'|| o === 'undefined' ) {
        return true;
    }
    return false;
}

export { formAtt, errorMessage, ApiUserInfo, base64ToBlob, downloadCurrentPdf, isEmpty };